import { render, staticRenderFns } from "./settingCertification.vue?vue&type=template&id=64add011&scoped=true"
import script from "./settingCertification.vue?vue&type=script&lang=js"
export * from "./settingCertification.vue?vue&type=script&lang=js"
import style0 from "./settingCertification.vue?vue&type=style&index=0&id=64add011&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64add011",
  null
  
)

export default component.exports